import type { OverWritable } from '../../@types/settings';

export const cssBaseline: OverWritable = {
  MuiCssBaseline: {
    styleOverrides: {
      '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      },
      html: {
        width: '100%',
        height: '100%',
        WebkitOverflowScrolling: 'touch',
      },
      body: {
        width: '100%',
        height: '100%',
      },
      '#__next': {
        width: '100%',
        height: '100%',
      }, // List
      '& ul, & ol': {
        paddingLeft: 24,
        '& li': {
          lineHeight: 2,
        },
      },
    },
  },
};
